var HotelRoomView;
(function (HotelRoomView) {
  HotelRoomView["GROUPEDBYROOMCONFIG"] = "GROUPEDBYROOMCONFIG";
  HotelRoomView["ROOMCONTAINSALLROOMCONFIG"] = "ROOMCONTAINSALLROOMCONFIG";
})(HotelRoomView || (HotelRoomView = {}));
var HotelRoomView$1 = HotelRoomView;

export { HotelRoomView$1 as default };
//# sourceMappingURL=HotelRoomView.js.map
